import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { NAV, CONTACT } from "./data";

const Wordmark = () => (
  <a href="#top" data-testid="nav-logo" className="flex flex-col leading-none select-none">
    <span className="font-display font-black text-2xl tracking-tight silver-text">P.M.R.</span>
    <span className="font-grotesk text-[9px] tracking-[0.32em] uppercase text-neutral-400">Physio · Mobil · Roider</span>
  </a>
);

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Wordmark />
        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.href.replace("#", "")}`}
              className="font-grotesk text-sm tracking-wide text-neutral-300 hover:text-white transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[var(--pmr-red)] transition-[width] duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href="#kontakt"
            data-testid="nav-cta"
            className="font-grotesk text-sm font-medium inline-flex items-center gap-2 rounded-full bg-[var(--pmr-red)] hover:bg-[var(--pmr-red-deep)] text-white px-5 py-2.5 transition-colors"
          >
            <Phone size={15} /> Termin anfragen
          </a>
        </nav>
        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menü"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <a key={n.href} href={n.href} onClick={() => setOpen(false)}
                  className="font-grotesk text-lg text-neutral-200" data-testid={`nav-mobile-${n.href.replace("#", "")}`}>
                  {n.label}
                </a>
              ))}
              <a href={CONTACT.phoneHref} className="font-grotesk text-[var(--pmr-red)] font-semibold flex items-center gap-2">
                <Phone size={16} /> {CONTACT.phone}
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
